// extracted by mini-css-extract-plugin
export var addButton = "_q7-0";
export var border = "_q7-8";
export var check = "_q7-h";
export var danger = "_q7-6";
export var dropdownContainer = "_q7-1";
export var editModalBody = "_q7-j";
export var footerContainer = "_q7-i";
export var fullWidth = "_q7-a";
export var hide = "_q7-9";
export var icon = "_q7-3";
export var input = "_q7-7";
export var inputFlex = "_q7-b";
export var inputWrapper = "_q7-c";
export var manualFocus = "_q7-5";
export var optionButton = "_q7-4";
export var pillWrapper = "_q7-e";
export var pointer = "_q7-2";
export var showOverflow = "_q7-f";
export var tagsFlex = "_q7-d";
export var xButton = "_q7-g";